import { Component,inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { DeviceService } from '../services/device-service/device.service';

@Component({
  selector: 'app-comment-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './comment-cell-renderer.component.html',
  styleUrl: './comment-cell-renderer.component.scss'
})
export class CommentCellRendererComponent implements ICellRendererAngularComp{



  public value: string = '';
public expanded: boolean = false;
public showToggle: boolean = false; // 👈 Only show toggle if 'peripheral' is in value
public params: any;
parentComponent:any;
rowIndex:any;
peripheralsArray:any;
  deviceService : DeviceService = inject(DeviceService);
  isDeleted:boolean = false;
  isUpdated:boolean=false;
  isNotCollapse:boolean=false;
agInit(params: any): void {

  this.params = params;
  this.value = params.value || 'N/A';
  this.rowIndex = params.rowIndex;

  const id = params.data?.id
  if(id){
    this.peripheralsArray = this.deviceService.fetchCurrentPageData[id].peripherals;
    console.log({PeriheralsArray:this.peripheralsArray})
  }

console.log({params})

  // this.parentComponent = params.context?.componentParent?.rowData;
//  this.parentComponent = this.deviceService.fetchCurrentPageData;
//   console.log('parent component ',this.parentComponent)
  // Show toggle only if 'peripheral' is present (case-insensitive)

  //this.showToggle = (params?.data?.eventType?.name.toLowerCase() ===  'installed' &&  params?.data?.peripherals !== null);

   if (params?.data?.eventType?.name?.toLowerCase() === 'installed' || params?.data?.eventType?.name?.toLowerCase() === 'installing' || params?.data?.eventType?.name?.toLowerCase() === 'deleted' || params?.data?.eventType?.name?.toLowerCase() === 'updated') {
    const status = params?.data?.eventType?.status;
    if ((status === 'Success' || status === 'In Progress') && params?.data?.peripherals !== null) {
      this.showToggle = true;
      if(params?.data?.eventType?.name?.toLowerCase() === 'deleted')
      {
        this.isDeleted = true;
        this.isUpdated=false;
        this.isNotCollapse=false;
      }
      else if(params?.data?.eventType?.name?.toLowerCase() === 'updated')
      {
        this.isUpdated=true;
        this.isDeleted = false;
        this.isNotCollapse=false;
      }
      else if(params?.data?.eventType?.name?.toLowerCase() === 'installed' || params?.data?.eventType?.name?.toLowerCase() === 'installing')
      {
        this.isNotCollapse = true;
        this.isUpdated=false;
        this.isDeleted=false;

      }
    }
    else {
      this.showToggle = false;
    }
  } else {
    this.showToggle = false;
  }


  this.expanded = !!params.data?._expanded;
  console.log('there')
}

refresh(): boolean {
  return false;
}

toggleExpand(): void {
  if (!this.showToggle) return; // Don't toggle if not allowed

  this.expanded = !this.expanded;
  if (this.params && this.params.data) {
    this.params.data._expanded = this.expanded;
  }

  if (this.params.api && this.params.node) {
    //this.params.api.resetRowHeights();
  }
}

// issue#2398 start
// Description: No inline copy handler present by design; the Device History component's context menu builds a comprehensive copy (details + peripherals)
// issue#2398 end


}
